module.exports = __webpack_public_path__ + "img/delete.8db7ae2f.svg";